export enum VideoType {
  Panoramic = 'pan',
  Tv = 'tv',
  Tactical = 'tac',
  Live = 'live'
}
